import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WishlistHotelsResponse, WishlistResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class WishlistService {
  constructor(private http: HttpClient) {}

  getWishlistHotelsByCountryId(countryId: number): Observable<WishlistHotelsResponse> {
    return this.http.get<WishlistHotelsResponse>(`/new/wishlist/get-wishlist-hotels-by-country-id`, {
      params: { countryId },
    });
  }

  addHotelToWishlist(hotelId: number): Observable<WishlistResponse> {
    return this.http.get<WishlistResponse>(`/new/wishlist/add-wishlist-hotel`, {
      params: { hotelId },
    });
  }

  removeHotelFromWishlist(hotelId: number): Observable<WishlistResponse> {
    return this.http.get<WishlistResponse>(`/new/wishlist/remove-wishlist-hotel`, {
      params: { hotelId },
    });
  }
}
